import React from "react";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import {observer} from "mobx-react";

class TemperatureSection extends React.Component {
    static contextType = storesContext;

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        if (!orderStore.displayTemperatures) {
            return null;
        }
        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.temperature.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.order.details.temperature.properties.requestedTemp1")}
                            validatedValue={orderStore.requestedTemp1}
                            testId="requested-temperature-one"
                            unit="°C"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.temperature.properties.requestedTemp2")}
                            validatedValue={orderStore.requestedTemp2}
                            testId="requested-temperature-two"
                            unit="°C"
                            offAutocomplete
                        />
                    </Row>
                </div>
            </div>
        );
    }
}

export default observer(TemperatureSection);
